<template>
<div class="forget-container">
    <div class="forget-bg">
        <!-- schoolLogo -->
        <div class="forget-schoolLogo">
            <img :src="schoolLogoUrl" alt="">
        </div>
        <!-- 找回密码内容区 -->
        <div class="forget-wrapper">
            <div class="forget-password">
                <img :src="forgetLogoSrc" alt="">
                <div class="forger-text">找回密码</div>
            </div>
            <div class="forget-back">
                <div class="forget-backtext">
                    <router-link to="login">返回首页</router-link>
                </div>
                <img :src="backSrc" alt="">
            </div>
            <!-- 步骤 -->
            <div class="forget-steps">
                <el-steps :active="stepsActive" finish-status="success" align-center>
                    <el-step title="身份认证"></el-step>
                    <el-step title="重置密码"></el-step>
                    <el-step title="完成"></el-step>
                </el-steps>  
                <div class="forget-stepCon">
                    <div class="forget-step1" :class="showStep==1?'showStep':'hideStep'">
                        <div class="forget-tel forget-item">
                            <span class="lable_text"> 手机号：</span>
                            <el-input placeholder="" ref="tel"
                            v-model="tel"
                            name="tel"
                            type="text" 
                            tabindex="1"
                            auto-complete="on"
                            ></el-input>
                        </div>
                        <div class="forget-code forget-item">
                            <span class="lable_text"> 验证码：</span>
                            <el-input placeholder="" ref="code"
                            v-model="code"
                            name="code"
                            type="text"
                            tabindex="1"
                            auto-complete="on"
                            ></el-input>
                        </div>
                        <div class="forget-getcode" @click="getCaptcha" :class="ifClick?'noclick':''">
                              {{entityText}}  
                        </div>
                       <el-button :loading="loading" type="primary"   class="forget-queding" @click="finshStep1">确定</el-button>

                    </div>
                    <div class="forget-step2" :class="showStep==2?'showStep':'hideStep'">
                        <div class="forget-tel forget-item">
                            <span class="lable_text"> 输入密码：</span>
                            <el-input placeholder="" ref=""
                            v-model="createDto.NewPwd"
                            name="tel"
                            type="password"
                            tabindex="1"
                            auto-complete="on"
                            ></el-input>
                        </div>
                        <div class="forget-code forget-item">
                            <span class="lable_text">确认密码：</span>
                            <el-input placeholder="" ref="code"
                            v-model="createDto.NewPwdAgin"
                            name="code"
                            type="password"
                            tabindex="1"
                            auto-complete="on"
                            ></el-input>
                        </div>
                       <el-button :loading="loading" type="primary"   class="forget-queding" @click="finshStep2">确定</el-button>
                    </div>
                    <div class="forget-step3" :class="showStep==3?'showStep':'hideStep'">
                        <img :src="successStepSrc" alt="">
                        <el-button :loading="loading" type="primary"   class="forget-login" @click="finshStep3">去登录</el-button>

                    </div>
                </div>
            </div>
        </div>
        <!-- logo -->
        <div class="forget-logobox">
            <img :src="logoSrc" alt="" class="logo_img">
            <!-- <div class="banquan_text">版权所有 ©&nbsp;&nbsp;&nbsp;&nbsp;粤ICP备15109747号</div> -->
      </div>
    </div>
</div>
</template>
<script>
//ReFindPwd
const TIME_OUT = 60;
export default {
    data(){
        return {
            tel:"",
            code:"",
            schoolLogoUrl:"",
            logoSrc:"",
            forgetLogoSrc:"",
            backSrc:"",
            stepsActive:0,
            entityText:"获取验证码",
            timeOut: TIME_OUT,
            loading:false,
            showStep:1,
            successStepSrc:"",
            Times:1,
            ifClick:false,
            createDto:{
                PhoneNum:"",
                NewPwd:"",
                NewPwdAgin:""
            },
            ifSedCode:false,
            timeID:null
        }
    },
    methods:{
        getCaptcha() {
        var that=this;
        var paramsData={
          PhoneNum:that.tel,
          Times:that.Times,
          MessageType:2
        }
        if(!(/^1[3456789]\d{9}$/.test(paramsData.PhoneNum))){
          this.$message({
            message: '请输入正确的手机号',
            type: 'error',
            duration: 5 * 1000
          })
            return;
        }
        that.getSendCode(paramsData);//获取验证码
        that.timeID = setInterval(function() {
          if (that.timeOut == 1) {
              that.Times++;
              that.entityText = '发送验证码';
              that.timeOut = TIME_OUT;
              that.smsFlag = false;
              clearInterval(that.timeID);
              that.ifClick=false;
          } else {
              that.entityText = that.timeOut-- + 's后获取';
              that.ifClick=true;
          }
        }, 1000);
      },
      getSendCode(paramsData){
        this.$api.getSendCode(paramsData).then(res => {
        console.log("sendMsg====",res);
          if(res&&res.data.result){
             this.$message({
              message: '验证码已发送',
              type: 'success',
              duration: 5 * 1000
            })

            // this.ifSedCode=true
          }else{
             this.$message({
              message: res.data.message,
              type: 'error',
              duration: 5 * 1000
            })
          }
        })
      },
        finshStep1(){
            var that= this;
            var checkCodeParams ={
                PhoneNum:that.tel,
                VCode:that.code
            }
            if(that.code==""||that.tel==""){
                this.$message({
                    message: "请先验证手机号",
                    type: 'error',
                    duration: 5 * 1000
                });
                return false; 
            }
            that.$api.ReFindPwdCheckVCode(checkCodeParams).then(res=>{
                if(res.data.result){
                    that.stepsActive=1;
                    that.showStep=2;
                }else{
                    this.$message({
                        message: "请先验证手机号",
                        type: 'error',
                        duration: 5 * 1000
                    }) 
                }
            })
            
            
        },
        finshStep2(){
            var that= this;
            if(that.createDto.NewPwd!=""){
                if(that.createDto.NewPwd!=that.createDto.NewPwdAgin){
                    this.$message({
                        message: "两次输入密码不一致",
                        type: 'error',
                        duration: 5 * 1000
                    })   
                }else{
                    var createDtoParams = {
                        PhoneNum:that.tel,
                        NewPwd:that.createDto.NewPwd
                    }
                    that.$api.ReFindPwd(createDtoParams).then(res=>{
                        if(res.data.result){
                            this.$message({
                                message: "提交成功",
                                type: 'success',
                                duration: 5 * 1000
                            })
                            that.stepsActive=2;
                            that.showStep=3;
                        }else{
                            this.$message({
                                message: res.data.message,
                                type: 'error',
                                duration: 5 * 1000
                            })
                        }
                    })
                }
            }
            
            
           
        },
        finshStep3(){
            var that= this;
            that.stepsActive=4;
            that.showStep=3;
            this.$router.push({ path: "login" || '/' })
        }
    },
    destroyed(){
        var that = this;
        clearInterval(that.timeID);
    }
}
</script>
<style lang="scss">
$bg:#2850a7;
$color:#2850a7;

.forget-container{
    width:100%;
    height:100%;
    background: #2850a7;
    .forget-bg{
        width:1200px;
        margin:0 auto;
        padding-top:60px;
        .forget-schoolLogo{
            width:239px;
            margin:0 auto;
            margin-bottom:50px; 
        }
        .forget-wrapper{
            width:800px;
            height:475px;
            background: #fff;
            margin: 0 auto;
            border-top:7px solid #376df1;
            background:-webkit-gradient(linear, 0 0, 0 8%, from(#d5edff), to(#fff));
            
          //  background: -o-linear-gradient(#d5edff, #fff); /* Opera 11.1 - 12.0 */
            //background: -moz-linear-gradient( #d5edff, #fff); /* Firefox 3.6 - 15 */
            //background: linear-gradient(#d5edff, #fff); /* 标准的语法 */
            .forget-password{
                display:flex;
                align-items: center;
                margin-top:35px;
                margin-left:45px;
                width:160px;
                .forger-text{
                    font-size:24px;
                    color:$color;
                    font-weight: bold;
                    margin-left:12px;
                }
            }
            .forget-back{
                display: flex;
                align-items: center;
                float: right;
                color: $color;
                font-size: 14px;
                margin-right: 45px;
                margin-top: -26px; 
                .forget-backtext{
                    margin-right:5px;
                }
            }
            .forget-steps{
                padding-top:70px;
                .el-step__head.is-process{
                    color:$color;
                    border-color:$color;
                }
                .el-step__title.is-process{
                    color:$color;
                }
            }
            .forget-stepCon{
              padding-top:40px;  
            }
            .showStep{
                display:block;
            }
            .hideStep{
                display:none;
            }
            .forget-step1,.forget-step2{
                position: relative;
                .forget-item{
                    display: flex;
                    align-items: center;
                    border-bottom:1px solid $color;
                    width:300px;
                    margin:0 auto;
                    margin-bottom:20px;
                    color:$color;
                    font-size:16px;
                    .lable_text{
                        width:110px;
                    }
                    .el-input__inner{
                        border:none;
                        padding-left:0;
                    }
                }
                .forget-queding{
                    width:300px;
                    margin-bottom:30px;
                    font-size:20px;
                    font-weight:bold;
                    border-radius:0px;
                    margin-left:250px;
                    margin-top:30px;
                }
                .forget-getcode{
                    // width: 94px;
                    padding:5px ; 

                    // height:28px;
                    // line-height:28px;
                    text-align: center;
                    cursor: pointer;
                    background: #2850a7;
                    color:#fff;
                    font-size:16px;
                    border-radius: 5px;
                    position: absolute;
                    top: 62px;
                    right: 250px;

                }
            }
            .forget-step3{
                width:130px;
                margin:0 auto;
                img{
                    display:block;
                }
                .forget-login{
                    width: 300px;
                    margin-top: 15px;
                    margin-left: -80px;
                    font-size:20px;
                    font-weight: bold;
                    border-radius: 0px;
                }
            }

            
          
        }
        :root .forget-wrapper{filter:none;}
        .forget-logobox{
            width:226px;
            font-size:14px;
            color:#fff;
            margin:0 auto;
            margin-top:40px;
        }
    }
    .banquan_text{
        margin-top:20px;
        font-size:14px;
    }
    .noclick{
		pointer-events: none;
    }
}
.el-button--primary{
    background-color: #2850a7;
    border-color: #2850a7;
}
.el-button--primary:hover{
    background: #064382;
    border-color: #064382;
}
</style>
   




// WEBPACK FOOTER //
// forgetPwd.vue?0e4285c9